import { ITaskMetricsView } from '@commenda/types/src/service-request/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { API_BASE_PATH } from './constants';

export const useServiceRequestMetrics = () => {
  const { data, error, mutate } = useSWR<{
    data: ITaskMetricsView[];
  }>(
    `${API_BASE_PATH}/metrics`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data,
    error,
    mutate,
  };
};
